'use client';

import { Button, Modal } from '@components/common';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { InterviewSelectorContent } from '@components/features/interview/InterviewSelectorContent';

interface InterviewSelectorProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * @description Modal selector for interview options (Video / Audio / Text)
 */
export const InterviewSelector = ({ isOpen, onClose }: InterviewSelectorProps) => (
  <Modal isOpen={isOpen} onClose={onClose} size="sm" className="!p-0">
    <div className="relative px-4 py-10 text-center text-ink">
      {/* Close button */}
      <Button
        onClick={onClose}
        styling="solid"
        rounding="full"
        color="ink"
        className="absolute right-2 top-2 flex aspect-square items-center justify-center !p-1"
        aria-label="Close"
      >
        <XMarkIcon className="size-4" />
      </Button>

      <InterviewSelectorContent />
    </div>
  </Modal>
);

export default InterviewSelector;
